import React from 'react';
import SwaggerUI from 'swagger-ui-react';
import AsyncApiComponent from '@asyncapi/react-component/browser';

import {DOCUMENT_TYPE_ASYNCAPI, DOCUMENT_TYPE_SWAGGER} from './utils/spec-type';

export default function SpecViewer({type = DOCUMENT_TYPE_SWAGGER, spec, onComplete}) {
  switch (type) {
    case DOCUMENT_TYPE_SWAGGER:
      return <SwaggerUI spec={spec} onComplete={onComplete} docExpansion="list" />;
    case DOCUMENT_TYPE_ASYNCAPI:
      return <AsyncApiComponent schema={spec} config={{}} />;
    default:
      return <div>Document {type} not supported.</div>;
  }
}
